import { gql } from '@apollo/client'
import employeeDisplayFragment from './fragments/employeeDisplay.fragment'
import employeeManagerOfCompaniesFragment from './fragments/employeeManagerOfCompanies.fragment'
import employeeBUFragment from './fragments/employeeBU.fragment'
import employeeCoreFragment from './fragments/employeeCore.fragment'
import employeesAndAppraisalsFragment from './fragments/employeesAndAppraisals.fragment'
import employeeDisplayTinyInfoFragment from './fragments/employeeDisplayTinyInfo.fragment'

export const EMPLOYEE = gql`
  query Employee(
    $id: HashedId!
    $checkPermissions: Boolean = false
    $withDisplay: Boolean = false
    $withManagerOfCompanies: Boolean = false
  ) {
    employee(id: $id, checkPermissions: $checkPermissions) {
      id
      ...EmployeeDisplay @include(if: $withDisplay)
      ...ManagerOfCompanies @include(if: $withManagerOfCompanies)
    }
  }
  ${employeeDisplayFragment}
  ${employeeManagerOfCompaniesFragment}
`
export const SUBORDINATES_BY_EMPLOYEE = gql`
  query SubordinatesByEmployee($employeeId: HashedId!) {
    subOrdinatesByEmployee(id: $employeeId) {
      id
      ...EmployeeDisplay
      ...EmployeeBU
    }
  }
  ${employeeDisplayFragment}
  ${employeeBUFragment}
`

export const COMPANY_PARTNERS_OF_EMPLOYEE = gql`
  query CompanyPartnersOfEmployee($employeeId: HashedId!) {
    companyPartners(employeeId: $employeeId) {
      id
      ...EmployeeCore
    }
  }
  ${employeeCoreFragment}
`

export const EMPLOYEES_BY_NAME = gql`
  query EmployeeByName($searchString: String!, $limit: Int) {
    nameSearch(limit: $limit, rawInput: $searchString) {
      id
      legalFirstName
      legalLastName
      chosenFirstName
      chosenLastName
      buName
      companyName
      avatarUrl
    }
  }
`

export const EMPLOYEES_AND_APPRAISALS = gql`
  query NonManagerEmployeesOfCompanyWithCurrentAppraisalMeeting($companyId: HashedId!, $country: Country!) {
    nonManagerEmployeesOfCompanyWithCurrentAppraisalMeeting(companyId: $companyId, country: $country) {
      ...EmployeesAndAppraisals
    }
    currentAppraisalSeason(companyId: $companyId, country: $country) {
      year
    }
    employeeLevels: getCountryEmployeeLevels(country: $country)
  }
  ${employeesAndAppraisalsFragment}
`

export const EMPLOYEES_WITH_HR_OR_DOWNLOADER_ROLE = gql`
  query employeesWithHrOrDownloaderRole {
    employeesWithHrOrDownloaderRole {
      id
      firstName
      lastName
      currentLevel
      avatarUrl
      companyName
      buName
      hrRoleOfUser {
        id
        userId
        fromDate
        role {
          id
          name
        }
      }
      assignedTo
      hasDownloaderRole
    }
  }
`

export const COMPANY_AND_BU = gql`
  query companiesAndBusinessUnitsByEmployee($id: HashedId!, $country: Country!) {
    companiesAndBusinessUnitsByEmployee(id: $id) {
      companyId
      companyName
      bu {
        buId
        displayName
        isAllBu
      }
    }
    employeeLevels: getCountryEmployeeLevels(country: $country)
  }
`
export const BU_EMPLOYEES_AND_APPRAISALS = gql`
  query NonManagerEmployeesOfBusinessUnitWithCurrentAppraisalMeeting($businessUnitId: HashedId!, $country: Country!) {
    nonManagerEmployeesOfBusinessUnitWithCurrentAppraisalMeeting(businessUnitId: $businessUnitId) {
      ...EmployeesAndAppraisals
    }
    employeeLevels: getCountryEmployeeLevels(country: $country)
  }
  ${employeesAndAppraisalsFragment}
`

export const EMPLOYEE_LEVELS_BY_COUNTRY = gql`
  query EmployeeLevelsByCountry($country: Country!) {
    employeeLevels: getCountryEmployeeLevels(country: $country)
  }
`

export const APPRAISALS_OF_EMPLOYEE_BY_YEAR = gql`
  query appraisalsOfEmployeeByYear($employeeId: HashedId!, $latestMeetingId: HashedId!, $appraisalSeasonYear: Int!) {
    appraisalsOfEmployeeByYear(employeeId: $employeeId, latestMeetingId: $latestMeetingId, appraisalSeasonYear: $appraisalSeasonYear) {
      id
      date
      hrFeedBack
      hrDisputeComment
      hrResult
      meetingStatus
      meetingType
      type {
        name
        reason
        skippedSteps
      }
      reviewer {
        ...EmployeeDisplayTinyInfo
      }
      confirmation {
        date
        discussedWith {
          ...EmployeeDisplayTinyInfo
        }
        forceConfirmedBy {
          ...EmployeeDisplayTinyInfo
        }
        forceConfirmedReason
      }
      conclusionPdf {
        fileName
        downloadToken
        status
      }
      status {
        name
        sortOrder
      }
      appraisalSeason {
        id
        companyId
        country
        year
        fromDate
        toDate
      }
      companyNameOfMeeting
    }
  }
  ${employeeDisplayTinyInfoFragment}
`

export const ACTIVE_EMPLOYEE_SEARCH = gql`
  query ActiveEmployeesSearch($search: String!, $limit: Int, $kudosView: Boolean!, $companyId: HashedId) {
    activeEmployeesSearch(search: $search, limit: $limit, kudosView: $kudosView, companyId: $companyId) {
      id
      firstName
      lastName
      avatarUrl
      companyName
      businessUnitName
      contractLevel
      replyEntryDate
      contractValidTo
      employmentStatus
    }
  }
`
